import * as React from 'react';

import type {FormattedDurationValue} from 'nutshell-core/types';

type Props = {
    value: FormattedDurationValue;
};

/*
 * Component used to display time-based stats, such as
 * "Total activities duration". Looks like "4h 50m"
 */
export class DurationStat extends React.PureComponent<Props> {
    render() {
        return (
            /* Todo: Add a title attribute here once we have better formatting */
            <div>
                <span>{this.props.value.formatted}</span>
            </div>
        );
    }
}
